import { Modal, Form } from "react-bootstrap";
import backIcon from "../../../../images/arrow-left-solid.png";
import ErrorAlert from "../../../../common/ui/ErrorAlert";

export default function OtpModalPage(props) {
    const formData = props.loyaltyMember.OtpModalPage;
    let spinnerResendOtp = props.loyaltyMember.ServerCalls.SendOtpSms ? <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> : <></>
    let isDisabled = props.loyaltyMember.ServerCalls.SendOtpSms ? 
        {
            pointerEvents: "none",
            color: "#21252980"
        }:
        {}

    return (
        <>
            <div className="modal-header justify-content-start">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackOtpPage} disabled={formData.GeneralError.ButtonsDisabled}>
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5">&emsp;Loyalty Login</h1>
            </div>
            <Modal.Body>
                <div className="row justify-content-center mx-0 gy-4 mb-2">
                    <div className="col-sm-10 col-12 text-center">
                        Please enter the One Time Password (OTP) sent to the mobile number {props.loyaltyMember.MobileModalPage.Fields.authmobile.Value}
                    </div>
                    <div className="col-sm-10 col-12">
                        <Form.Floating>
                            <Form.Control type="tel" id="txtAuthOtp" name="authotp" className={formData.Fields.authotp.HasError ? "is-invalid" : ""} value={formData.Fields.authotp.Value} onChange={props.handleChangeOtpFields} maxLength={formData.Fields.authotp.MaxLength} disabled={formData.GeneralError.ButtonsDisabled}></Form.Control>
                            <Form.Control.Feedback type="invalid">{formData.Fields.authotp.ErrorMessage}</Form.Control.Feedback>
                            <label htmlFor="txtAuthOtp">OTP</label>
                        </Form.Floating>
                    </div>
                    <div className="col-sm-10 col-12 justify-content-center">
                        <button type="button" className="btn btn-dark rounded-pill w-100" onClick={props.handleNextValidateOtp} disabled={formData.GeneralError.ButtonsDisabled}>
                            Next
                            { formData.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>  
                    </div>
                    { props.loyaltyMember.ServerCalls.ResendOtpCountdownSeconds === 0 && !formData.GeneralError.ButtonsDisabled && 
                    <div className="text-center">
                        <a className="link-underline link-underline-opacity-0" href="#" onClick={props.handleResendOtpToMobile} style={isDisabled}>Resend One Time Password (OTP){spinnerResendOtp}</a>
                    </div> } 
                    { formData.GeneralError.HasError && <div className="col-sm-10 col-12"><ErrorAlert message={formData.GeneralError.ErrorMessage} /></div> }
                    <div className="d-flex flex-row align-items-center">
                        <hr className="w-100"/>
                        <small className="px-3 text-muted">OR</small>
                        <hr className="w-100"/>
                    </div>
                    <div className="col-sm-10 col-12 justify-content-center">
                        <button type="button" className="btn btn-outline-dark rounded-pill w-100" onClick={props.handleClickCloseLoyaltyModal} disabled={formData.GeneralError.ButtonsDisabled}>Continue as guest</button>
                    </div>
                </div>
            </Modal.Body>
        </>
    )
}